export function isPreviewEnv() {
    return Boolean(window?.env?.__IS_PREVIEW_ENV)
}
